var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconBadgeCc = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 6H3V18H21V6ZM3 4C1.89543 4 1 4.89543 1 6V18C1 19.1046 1.89543 20 3 20H21C22.1046 20 23 19.1046 23 18V6C23 4.89543 22.1046 4 21 4H3ZM5 11C5 9.34315 6.34315 8 8 8H11V10H8C7.44772 10 7 10.4477 7 11V13C7 13.5523 7.44772 14 8 14H11V16H8C6.34315 16 5 14.6569 5 13V11ZM16 8C14.3431 8 13 9.34315 13 11V13C13 14.6569 14.3431 16 16 16H19V14H16C15.4477 14 15 13.5523 15 13V11C15 10.4477 15.4477 10 16 10H19V8H16Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconBadgeCc);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "media/IconBadgeCc.fad7bf47504cdaa876529c4685e5a046.svg";